
/**
 * Since the footer height can vary depending on the screen size and the number of menu links, it's bad to hard code to an fixed value.
 * This code will get the footer size and set the --footer-size variable on the run.
 */

function setFooterHeight() {
  let footerHeight = document.getElementById('shopify-section-footer').clientHeight;
  document.documentElement.style.setProperty('--footer-height', `${footerHeight - 40}px`);

}

$(document).ready(function () {
  setFooterHeight();
});

$(window).on('resize', function () {
  setFooterHeight();
})
